module.exports = __webpack_public_path__ + "img/project4_2.png.197c0750.webp";